// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1S6r4","range":"MonthRangeSwitch_range__3bsGJ","disabled":"MonthRangeSwitch_disabled__12obB"};